import { Button, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { ArrowSquareOutIcon, GlobeSimpleIcon } from "@phosphor-icons/react";
import { isIOS, openInBrowser } from "helpers/webview";
import styled from "styled-components";
import { radius } from "@libertify/ui";

const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 20px;
  margin-bottom: 20px;
  border-radius: ${radius.box}px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
`;

const IconCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${radius.circle};
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const InAppBrowserBanner = () => {
  const t = useTranslate();
  return (
    <BannerWrapper role="status">
      <IconCircle>
        <GlobeSimpleIcon
          size={24}
          color="#434343"
          weight="duotone"
          aria-hidden="true"
        />
      </IconCircle>
      <Typography.Text
        strong
        style={{ fontSize: 16, color: "#262626", marginBottom: 6 }}
      >
        {t("pages.login.inAppBrowser.title")}
      </Typography.Text>
      <Typography.Text
        style={{
          fontSize: 14,
          color: "#595959",
          marginBottom: 20,
          lineHeight: 1.5,
        }}
      >
        {t("pages.login.inAppBrowser.description")}
      </Typography.Text>
      <Button
        type="primary"
        shape="round"
        icon={<ArrowSquareOutIcon size={16} aria-hidden="true" />}
        onClick={openInBrowser}
        size="large"
        style={{ width: "100%" }}
      >
        {t("pages.login.inAppBrowser.openInBrowser")}
      </Button>
      {isIOS() && (
        <Typography.Text
          style={{
            display: "block",
            marginTop: 12,
            fontSize: 12,
            color: "#595959",
          }}
        >
          {t("pages.login.inAppBrowser.iosInstructions")}
        </Typography.Text>
      )}
    </BannerWrapper>
  );
};
